import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAX = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M49.139 31.523c.56-2.08.861-4.266.861-6.522 0-2.257-.3-4.442-.861-6.522L22.826.096a24.873 24.873 0 0 0-13.043 5.07L.86 18.48A25.028 25.028 0 0 0 0 25.001c0 2.243.297 4.417.851 6.485l8.932 13.35a24.872 24.872 0 0 0 13.043 5.07l26.313-18.383Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M.861 31.521a25.021 25.021 0 0 0 8.922 13.313V31.521H.86ZM22.826 49.904c.717.062 1.441.095 2.174.095 11.55 0 21.27-7.834 24.139-18.478H22.826v18.383ZM49.139 18.478C46.27 7.834 36.55 0 25 0c-.733 0-1.457.033-2.174.095v18.383H49.14ZM9.783 5.167A25.021 25.021 0 0 0 .86 18.479h8.922V5.167Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M49.788 21.74H19.565V.593a24.83 24.83 0 0 0-6.522 2.446v18.7H.213a25.213 25.213 0 0 0 0 6.52h12.831v18.7a24.831 24.831 0 0 0 6.522 2.446V28.26h30.223a25.26 25.26 0 0 0 0-6.522Z"
}));
FlagAX.displayName = 'FlagAX';
export default withFlagWrapper(FlagAX);
//# sourceMappingURL=index.js.map